// Sound utility for playing building click sounds and other sound effects

export const buildingSounds: Record<number, string> = {
  3: '/sounds/fx/cleg.sfxc',  // Building type 1
  5: '/sounds/fx/iron.sfxc',  // Building type 2
  4: '/sounds/fx/stone.sfxc',  // Resource building (reuse sound 1)
  6: '/sounds/fx/barracks.sfxc',
  12: '/sounds/fx/dungeon.sfxc',
  15: '/sounds/fx/marketplace.sfxc',
  16: '/sounds/fx/referrals.sfxc',
  17: '/sounds/fx/guild.sfxc',
  18: '/sounds/fx/mylands.sfxc',
  19: '/sounds/fx/treasure.sfxc',
};

export class SoundUtils {
  private static audioContext: AudioContext | null = null;
  private static soundCache: Map<string, AudioBuffer> = new Map();

  private static getAudioContext(): AudioContext {
    if (!this.audioContext) {
      const AudioContext = window.AudioContext || (window as any).webkitAudioContext;
      this.audioContext = new AudioContext();
    }
    return this.audioContext;
  }

  // Play a sound effect with volume control
  static async playSound(soundPath: string, volume: number = 1.0): Promise<void> {
    try {
      const audioContext = this.getAudioContext();

      // Resume context if suspended
      if (audioContext.state === 'suspended') {
        await audioContext.resume();
      }

      let audioBuffer = this.soundCache.get(soundPath);

      // Load and cache the sound if not already cached
      if (!audioBuffer) {
        const response = await fetch(soundPath);
        const arrayBuffer = await response.arrayBuffer();
        audioBuffer = await audioContext.decodeAudioData(arrayBuffer);
        this.soundCache.set(soundPath, audioBuffer);
      }

      // Create audio nodes
      const source = audioContext.createBufferSource();
      const gainNode = audioContext.createGain();

      // Configure audio
      source.buffer = audioBuffer;
      gainNode.gain.value = Math.max(0, Math.min(1, volume));

      // Connect nodes
      source.connect(gainNode);
      gainNode.connect(audioContext.destination);

      // Play the sound
      source.start();

    } catch (error) {
      console.error('Error playing sound:', error);
    }
  }

  // Play building click sound based on building type
  static async playBuildingSound(buildingId: number, volume: number = 0.5): Promise<void> {
    const soundPath = this.getBuildingSoundPath(buildingId);
    console.log(soundPath,volume,buildingId);
    if (soundPath) {
      await this.playSound(soundPath, volume);
    }
  }



  // Map building IDs to their sound files
  private static getBuildingSoundPath(buildingId: number): string | null {

    return buildingSounds[buildingId] || '/fx/building-click-1.wav'; // Default sound
  }

  // Clear sound cache (useful for memory management)
  static clearCache(): void {
    this.soundCache.clear();
  }

  // Preload sounds for better performance
  static async preloadSounds(soundPaths: string[]): Promise<void> {
    const promises = soundPaths.map(path => this.playSound(path, 0));
    await Promise.all(promises);
  }
} 